<script>
  import Screen from "./screen.svelte"
  import Card from "./Card.svelte"
  import alldata from "./data.json"
  import { dataset_dev } from "svelte/internal"

</script>

<Screen>
  <div class="flex">
    <div class=" max-w-4xl">
      <div class="bg-gray-200 text-green-900 text-left p-1">
        当前九阳名单:
        <pre>
姓名	层数	主内功
君奉天	7層	無望86雙脈
金宇碩老婆	7層	無望86雙脈
紫小草	4層	無望86雙脈
獨孤肥仔	3層	無望86雙脈
唐天賜	1層	無望86雙脈
大安彭于晏	1層	無望86雙脈
小天父	1層	無望86雙脈
小正太	1層	無望86雙脈
富察榮因	1層	無望86雙脈
餛飩巨籤	1層	無望86雙脈
平凡	1層	無望86雙脈
慕天城	1層	無望86雙脈
神氣小水滴	1層	逆天86單脈
神龍小王子	1層	混元86單脈
神奇小海螺	1層	五仙72深藏
        </pre>

      </div>
      <div class="bg-gray-200 text-green-900 text-left p-1">
        参赛选手一览：<br>
        {#each alldata as data}
          {#if data.upgrade !== "no"}
            <a class="text-black visited:text-white rounded shadow bg-blue-300 hover:bg-blue-700 hover:text-white m-1 border-solid border border-yellow-300"
            href="./#{data.number}">
                {data.number}: {data.name}
            </a>
          {/if}
        {/each}
        <br> 来乱的一览：<br>
        {#each alldata as data}
          {#if data.upgrade === "no"}
            <a class="text-black visited:text-black rounded shadow bg-grey-500 hover:bg-gray-700 hover:text-white m-1 border-solid border border-gray-300"
            href="./#{data.number}">
                {data.number}: {data.name}
            </a>
          {/if}
        {/each}
            <br>
            <br>
            <a class="text-black visited:text-black rounded shadow bg-grey-500 hover:bg-gray-700 hover:text-white m-1 border-solid border border-blue-700 p-3"
            href="./#submit">
            点击这里投票
            </a>
            <br>
            <br>

      </div>
      <div class="flex">
        <img src="./assets/imgs/cards/all.svg" width="500px" alt="" class="rounded-xl"/>
      </div>
      {#each alldata as data}
        <Card {data}></Card>
      {/each}
      
      <iframe title="" id="submit" src="https://docs.google.com/forms/d/e/1FAIpQLSeSBzny5lj3FInTbuldtDaxPe0BGwuru5BU4CTdzAg2UB7sBQ/viewform?embedded=true" width="640" height="841" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
    </div>
  </div>
</Screen>

<style>
.flex{
  justify-content:center;align-items:center;
  z-index: 99;
    background-color: rgb(32,0,1);
}



</style>